import {
    REQUEST_INCENTIVE, REQUEST_INCENTIVE_FAILURE, REQUEST_INCENTIVE_SUCCESS,
} from "../../constant/other/IncentiveConstant";

const initialState = {
    incentive: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const incentiveReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_INCENTIVE:
            return {
                ...state,
                incentive: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_INCENTIVE_SUCCESS:
            return {
                ...state,
                incentive: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_INCENTIVE_FAILURE:
            return {
                ...state,
                incentive: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
